import styled from 'styled-components';

const Title = styled.h1`
  margin-top: 15px;
`;

Title.displayName = 'Title';

export default Title;
